export default "__VITE_ASSET__BSfFFsJL__"